import React, { useState } from 'react';
import { askGrokForCode, askGrokToReview, GrokResponse } from '../utils/grokAPI';

interface GrokCodeTestProps {
  onClose: () => void;
}

const GrokCodeTest: React.FC<GrokCodeTestProps> = ({ onClose }) => {
  const [question, setQuestion] = useState('');
  const [response, setResponse] = useState<GrokResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState<'ask' | 'review'>('ask');
  const [codeToReview, setCodeToReview] = useState('');

  const handleAskGrok = async () => {
    if (!question.trim()) return;
    
    setLoading(true);
    try {
      const result = await askGrokForCode(question);
      setResponse(result);
    } catch (error) {
      setResponse({
        content: '',
        error: 'Failed to connect to Grok API'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReviewCode = async () => {
    if (!codeToReview.trim()) return;
    
    setLoading(true);
    try {
      const result = await askGrokToReview(codeToReview);
      setResponse(result);
    } catch (error) {
      setResponse({
        content: '',
        error: 'Failed to connect to Grok API'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
          <h2>Grok Code Fast 1 Test</h2>
          <button onClick={onClose} style={{ fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ marginRight: '1rem' }}>
            <input
              type="radio"
              checked={mode === 'ask'}
              onChange={() => setMode('ask')}
            />
            Ask Coding Question
          </label>
          <label>
            <input
              type="radio"
              checked={mode === 'review'}
              onChange={() => setMode('review')}
            />
            Review Code
          </label>
        </div>

        {mode === 'ask' && (
          <div style={{ marginBottom: '1rem' }}>
            <textarea
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Ask Grok a coding question..."
              style={{
                width: '100%',
                height: '100px',
                padding: '0.5rem',
                border: '1px solid #ccc',
                borderRadius: '4px'
              }}
            />
            <button
              onClick={handleAskGrok}
              disabled={loading || !question.trim()}
              style={{
                marginTop: '0.5rem',
                padding: '0.5rem 1rem',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {loading ? 'Asking Grok...' : 'Ask Grok'}
            </button>
          </div>
        )}

        {mode === 'review' && (
          <div style={{ marginBottom: '1rem' }}>
            <textarea
              value={codeToReview}
              onChange={(e) => setCodeToReview(e.target.value)}
              placeholder="Paste your code here for Grok to review..."
              style={{
                width: '100%',
                height: '150px',
                padding: '0.5rem',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontFamily: 'monospace'
              }}
            />
            <button
              onClick={handleReviewCode}
              disabled={loading || !codeToReview.trim()}
              style={{
                marginTop: '0.5rem',
                padding: '0.5rem 1rem',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              {loading ? 'Reviewing...' : 'Review Code'}
            </button>
          </div>
        )}

        {response && (
          <div style={{
            marginTop: '1rem',
            padding: '1rem',
            backgroundColor: response.error ? '#f8d7da' : '#d4edda',
            border: `1px solid ${response.error ? '#f5c6cb' : '#c3e6cb'}`,
            borderRadius: '4px'
          }}>
            {response.error ? (
              <div>
                <strong>Error:</strong> {response.error}
              </div>
            ) : (
              <div>
                <strong>Grok Response:</strong>
                <pre style={{
                  whiteSpace: 'pre-wrap',
                  marginTop: '0.5rem',
                  fontSize: '0.9rem'
                }}>
                  {response.content}
                </pre>
                {response.usage && (
                  <div style={{ marginTop: '1rem', fontSize: '0.8rem', color: '#666' }}>
                    Tokens: {response.usage.prompt_tokens} prompt + {response.usage.completion_tokens} completion = {response.usage.total_tokens} total
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default GrokCodeTest;